///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../abstract-command';
import { ActivityDTO } from '../../../../../services/project-socket/activity-dto.model';
import { GtthAutoDesignCommand } from './auto-design-command';
import { GtthLockProjectCommand } from '../project/lock-project-command';
import { GtthCanRunDesignCommand } from './can-run-design-command';
import { GtthProgressWindowModel } from '../../../../project-windows/progress-window/progress-window.model';
import { GtthUnlockProjectCommand } from '../project/unlock-project-command';
import { GtthLogicalTopology } from '../../../entities/logical-topology';
import { _cloneDeep } from '../../../../../shared/utils';

export class GtthMultipleAutoDesignCommand extends GtthAbstractCommand {
    getCommandName(): string {
        return 'GtthMultipleAutoDesignCommand';
    }

    create(): this {
        return this;
    }

    doCommand(): void {
        if (!GtthAutoDesignCommand.isPopInTopologyExist(this.historyService)) {
            this.commandResolve(false);
            return;
        }

        this.historyService.notificationService.clearAllMessages();

        this.historyService
            .doCommandBypassHistory(this.historyService.command(GtthCanRunDesignCommand))
            .then((canRunDesign: boolean) => {
                if (!canRunDesign) {
                    return Promise.reject();
                }

                this.historyService.progressWindowService.show(GtthProgressWindowModel.create(this.getCommandName()));
                return GtthAutoDesignCommand.checkNodesConnectivity(this.historyService);
            })
            .then((nodesAreConnected: boolean) => {
                if (!nodesAreConnected) {
                    return Promise.reject();
                }

                const unlockCommand = this.historyService.command(GtthUnlockProjectCommand);
                this.historyService.doCommandBypassHistory(unlockCommand, true);

                this.historyService.logicalTopology.clearDesignIterationInfo();

                if (this.historyService.logicalTopology.layers?.length > 0) {
                    this.historyService.logicalTopology.layers.forEach((_value, index) => {
                        GtthAutoDesignCommand.calculateSupportLayersMask(this.historyService, index);
                        if (index > 0) {
                            const isBottomUpDesign =
                                this.historyService.logicalTopology.autodesignP2mpPerLayer[GtthLogicalTopology.DEFAULT_CONFIG_LAYER_INDEX]
                                    .bottom_up;
                            this.historyService.logicalTopology.autodesignP2mpPerLayer[index].bottom_up = isBottomUpDesign;
                            this.historyService.logicalTopology.designRingsPerLayer[index].bottom_up = isBottomUpDesign;
                        }
                    });
                } else {
                    GtthAutoDesignCommand.calculateSupportLayersMask(this.historyService, GtthLogicalTopology.DEFAULT_CONFIG_LAYER_INDEX);
                }

                const activity = this.createActivityDTO(false);
                activity.logicalTopology = this.historyService.logicalTopology.toGeoJsonMainConfig(this.historyService, this.project.name);
                activity.designConfig = this.historyService.logicalTopology.getDesignConfig();
                this.sendActivity(activity);
            })
            .catch((error) => {
                console.log(error);
                this.historyService.progressWindowService.hide();
                this.commandResolve(false);
            });
    }

    doCommandActivity(activityDto: ActivityDTO): void {
        const progressDto = GtthProgressWindowModel.createFromActivityDTO(activityDto);

        this.historyService.progressWindowService.show(progressDto);

        if (progressDto.isCommandFinished()) {
            this.historyService.logicalTopology.designIterationsChartData = _cloneDeep(
                activityDto.logicalTopology.crs.properties.designIterationsChartData
            );

            if (this.historyService.canCommandLockProject) {
                progressDto.preloaderText = 'Locked by another user';
                this.historyService.progressWindowService.show(progressDto);

                const lockTimeout = this.commandResolve ? 0 : 1000;

                setTimeout(() => {
                    const lockCommand = this.historyService.command(GtthLockProjectCommand).create(false);
                    this.historyService.doCommandBypassHistory(lockCommand).then((result: boolean) => {
                        this.historyService.clearHistory();

                        if (!result) {
                            this.historyService.progressWindowService.hide();
                        } else {
                            progressDto.preloaderText = undefined;
                            this.historyService.progressWindowService.show(progressDto);
                        }
                        if (this.commandResolve) {
                            this.commandResolve(progressDto.isSuccessfull());
                        }
                    });
                }, lockTimeout);
            } else {
                this.historyService.progressWindowService.hide();
            }
        }
    }

    isDisabledInReadOnlyMode(): boolean {
        return true;
    }
}
